import React from "react";

const SectionContents = (props) => {
  const { sectionId, sectionTitle, sectionBody } = props;

  return (
    <div id={sectionId} className="scroll-mt-100">
      
      <div className="flex items-center gap-3 mb-4 pb-3 border-b-2 border-emerald-100">
        <div className="w-1 h-7 rounded-full bg-gradient-to-b from-emerald-500 to-purple-500" />

        <h2 className="text-xl font-bold title-text">
          {sectionTitle}
        </h2>
      </div>

      <div className="space-y-4 text-sm muted-text leading-relaxed">
        {sectionBody}
      </div>
    </div>
  );
};

export default SectionContents;